import * as React from "react"

const SvgComponent = (props) => (
  <svg
    width={15}
    height={15}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M8.724 1.45A1.4 1.4 0 0 0 7.492.741a1.4 1.4 0 0 0-1.232.707L.182 12.132c-.243.445-.243.97 0 1.414a1.4 1.4 0 0 0 1.232.707H13.57c.505 0 .97-.263 1.232-.707.263-.444.263-.97 0-1.414L8.724 1.45Zm5.029 11.49a.201.201 0 0 1-.182.101H1.414a.202.202 0 0 1-.182-.1c-.02-.041-.06-.122 0-.203L7.31 2.035c.04-.081.141-.101.181-.101.04 0 .122.02.182.1l6.079 10.704c.04.08.02.162 0 .202Z"
      fill="#636F7C"
    />
    <path
      d="M7.573 5.246a.595.595 0 0 0-.606.606v2.827c0 .344.262.606.606.606a.595.595 0 0 0 .606-.606V5.852a.608.608 0 0 0-.606-.606ZM7.573 9.89a.595.595 0 0 0-.606.606v.606c0 .344.262.606.606.606a.595.595 0 0 0 .606-.606v-.606a.608.608 0 0 0-.606-.605Z"
      fill="#636F7C"
    />
  </svg>
)

export default SvgComponent
